import { patchLessonProgress } from "@/api/api";

export default {
  computed: {
    direction() {
      if (this.$route.name === "practice") {
        return "practice";
      } else return "teach";
    },
    source() {
      if (this.direction === "practice") {
        return this.$store.getters["lesson/practice"];
      } else return this.$store.getters["lesson/teacher_lesson"];
    },
  },
  methods: {
    updateProgress(step) {
      let word;
      if (this.direction === "teach") {
        word = "teach_progress";
      } else word = "practice_progress";
      const progress = this.$store.getters["progress/lesson"];
      if (!progress[word][step]) {
        progress[word][step] = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }
    },
  },
};
